module.exports = __webpack_public_path__ + "img/Weapon_shield_01_static.c5bc6d29.png";